"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.accountGrade.list': 'Paquetes de Precios',
    'route.accountGrade.create': 'Crear Paquete de Precios',
    'route.accountGrade.edit': 'Editar Paquete de Precios',
    'route.accountGrade.preview': 'Vista Previa del Paquete de Precios',
};
